export * from '@erp/ui/collapsible';
